import firebase from "firebase";

// const firebaseConfig = {
//   apiKey: "AIzaSyDIXJ5YT7hoNbBFqK3TBcV41-TzIO-7n7w",
//   authDomain: "fir-auth-6edd8.firebaseapp.com",
//   projectId: "fir-auth-6edd8",
//   storageBucket: "fir-auth-6edd8.appspot.com",
//   messagingSenderId: "904760319835",
//   appId: "1:904760319835:web:44fd0d957f114b4e51447e",
//   measurementId: "G-Q4TYKH9GG7",
// };

const firebaseConfig = {
  apiKey: "AIzaSyCRVPS5B3ukNjGNIIXRbbVCbWtekyMEyHs",
  authDomain: "pwm-client-a465c.firebaseapp.com",
  projectId: "pwm-client-a465c",
  storageBucket: "pwm-client-a465c.appspot.com",
  messagingSenderId: "236329020374",
  appId: "1:236329020374:web:ba057e3a1c69f93bf01277"
};

const app = firebase.initializeApp(firebaseConfig);
const auth = app.auth();
const db = app.firestore();

export { db, auth };
